import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Panel.module.scss';
import useScroll from '../../../hooks/useScroll';

const getTopPosition = (element) => {
  return window.getComputedStyle(element).top;
};

function Panel(props) {
  const { fix, children } = props;

  let [sticky, setSticky] = useState(false);

  useEffect(() => {
    if (!fix) {
      const wrapperMenu = document.querySelector('.menu_wrapper');
      const closeButton = wrapperMenu.querySelector('.ic-close');
      const menuButton = wrapperMenu.querySelector('.ic-menu');

      const setStickyOnCloseClick = function (e) {
        if (getTopPosition(wrapperMenu) === '0px') {
          setSticky(true);
        }
      };

      const setUnStickyOnMenuClick = function (e) {
        if (getTopPosition(wrapperMenu) === '-56px') {
          setSticky(false);
        }
      };

      if (closeButton) {
        closeButton.addEventListener('click', setStickyOnCloseClick);
      }

      if (menuButton) {
        menuButton.addEventListener('click', setUnStickyOnMenuClick);
      }

      return () => {
        if (closeButton) {
          closeButton.removeEventListener('click', setStickyOnCloseClick);
        }

        if (menuButton) {
          menuButton.removeEventListener('click', setUnStickyOnMenuClick);
        }
      };
    }
  }, [fix]);

  useScroll(
    ({ prevPos, currPos }) => {
      if (fix) {
        return;
      }

      if (currPos.y > -56) {
        setSticky(false);
      } else if (currPos.y < prevPos.y) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    },
    [fix],
  );

  let classes;
  if (fix) {
    classes = styles.static_panel_info;
  } else {
    classes = cn(styles.panel_info, 'pagePanel', sticky ? styles.sticky : '');
  }

  return (
    <>
      <div style={{ height: '24px' }}></div>
      <div className={classes}>{children}</div>
    </>
  );
}

export default Panel;

Panel.defaultProps = {
  fix: false,
};

Panel.propTypes = {
  fix: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired,
};
